import { createSlice } from "@reduxjs/toolkit";

export const configSlice = createSlice({
    name: 'configuration',
    initialState : {
        //global
        language: 'es',
        breakpoint: 'lg',
        deviceType: 'laptop',
        resolution: -2,
        enUrlYoutubeVideo: null,
        esUrlYoutubeVideo: null,
        googleClientId: null,
        version: '',

        //windows
        openWaiting: false,
        openLogin: false,
        openSignup: false,
        openPasswordRecovery: false,
        openPasswordChange: false,
        openInviteFriend: false,
        openTermsOfUse: false,
    },
    reducers: {
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setBreakpoint: (state, action) => {
            state.breakpoint = action.payload;
        },
        setDeviceType: (state, action) => {
            state.deviceType = action.payload;
        },
        setResolution: (state, action) => {
            state.resolution = action.payload;
        },
        showSignup: (state, action) => {
            state.openSignup = action.payload;
        },
        showLogin: (state, action) => {
            state.openLogin = action.payload;
        },
        showPasswordRecovery: (state, action) => {
            state.openPasswordRecovery = action.payload;
        },
        showPasswordChange: (state, action) => {
            state.openPasswordChange = action.payload;
        },
        showWaiting: (state, action) => {
            state.openWaiting = action.payload;
        },
        showInviteFriend: (state, action) => {
            state.openInviteFriend = action.payload;
        },
        showTermsOfUse: (state, action) => {
            state.openTermsOfUse = action.payload;
        },
        setYoutubeVideo: (state, action) => {
            state.enUrlYoutubeVideo = action.payload.enUrlYoutubeVideo;
            state.esUrlYoutubeVideo = action.payload.esUrlYoutubeVideo;
        },
        setGoogleClientId: (state, action) => {
            state.googleClientId = action.payload.googleClientId;
        },
        setVersion: (state, action) => {
            state.version = action.payload;
        },
    }
})

export const { 
    setLanguage,
    setBreakpoint,
    setDeviceType,
    setResolution,
    showWaiting,
    showLogin,
    showSignup,
    showPasswordRecovery,
    showPasswordChange,
    showInviteFriend,
    showTermsOfUse,
    setYoutubeVideo,
    setGoogleClientId,
    setVersion,
} = configSlice.actions;